import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import BREADCRUMB_CONFIG, { shouldExcludeRoute } from "../Utils/breadcrumbConfig";

const useBreadcrumb = () => {
  const location = useLocation();

  useEffect(() => {
    const pathname = location.pathname;
    const search = location.search;

    if (shouldExcludeRoute(pathname)) {
      return;
    }

    try {
      let breadcrumbs = [];

      if (pathname === "/") {
        sessionStorage.removeItem(BREADCRUMB_CONFIG.storageKey);
        breadcrumbs = [];
      } else {
        const storedBreadcrumbs = sessionStorage.getItem(
          BREADCRUMB_CONFIG.storageKey
        );
        breadcrumbs = storedBreadcrumbs ? JSON.parse(storedBreadcrumbs) : [];
      }

      const fullPath = pathname + search;
      const lastBreadcrumb = breadcrumbs[breadcrumbs.length - 1];
      if (lastBreadcrumb?.fullPath === fullPath) {
        return;
      }

      const existingIndex = breadcrumbs.findIndex(
        (crumb) => crumb.fullPath === fullPath
      );

      if (existingIndex !== -1) {
        breadcrumbs = breadcrumbs.slice(0, existingIndex + 1);
      } else {
        breadcrumbs.push({
          pathname,
          search,
          fullPath,
          timestamp: new Date().getTime(),
        });
      }

      if (breadcrumbs.length > BREADCRUMB_CONFIG.maxBreadcrumbLength) {
        breadcrumbs = breadcrumbs.slice(-BREADCRUMB_CONFIG.maxBreadcrumbLength);
      }

      sessionStorage.setItem(
        BREADCRUMB_CONFIG.storageKey,
        JSON.stringify(breadcrumbs)
      );
    } catch (error) {
      console.error("Error updating breadcrumb:", error);
    }
  }, [location.pathname, location.search]);

  const getBreadcrumbs = () => {
    try {
      const storedBreadcrumbs = sessionStorage.getItem(
        BREADCRUMB_CONFIG.storageKey
      );
      return storedBreadcrumbs ? JSON.parse(storedBreadcrumbs) : [];
    } catch (error) {
      console.error("Error reading breadcrumbs:", error);
      return [];
    }
  };

  const getPreviousRoute = () => {
    const breadcrumbs = getBreadcrumbs();
    if (breadcrumbs.length >= 2) {
      return breadcrumbs[breadcrumbs.length - 2].fullPath;
    }
    return null;
  };

  const clearBreadcrumbs = () => {
    try {
      sessionStorage.removeItem(BREADCRUMB_CONFIG.storageKey);
    } catch (error) {
      console.error("Error clearing breadcrumbs:", error);
    }
  };

  const clearBreadcrumbsForNewSession = () => {
    clearBreadcrumbs();
  };

  return {
    getBreadcrumbs,
    getPreviousRoute,
    clearBreadcrumbs,
    clearBreadcrumbsForNewSession,
  };
};

export default useBreadcrumb;
